import React, { useEffect, useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import cx from 'classnames';
import s from './DataInput.module.css';
import sg from '../../../styles/index.module.css';
import classNames from 'classnames';
import moment from 'moment';

export function DateInput({
    date,
    requestUrl,
    parameterName,
    callback = null,
    options,
    title = null,
    isRequired = false,
    newCallback = null,
    isDisabled = false,
    newCallbackNotSingle = null,
    placeholder = null,
    newCallbackNotSingleCancel = null,
}) {
    const [inputValue, setInputValue] = useState(date);
    const locale = {
        format: i18next.t('DateInput.locale.format'),
        firstDay: 1,
        daysOfWeek: [
            i18next.t('DateInput.locale.format.daysOfWeek.sunday'),
            i18next.t('DateInput.locale.format.daysOfWeek.monday'),
            i18next.t('DateInput.locale.format.daysOfWeek.tuesday'),
            i18next.t('DateInput.locale.format.daysOfWeek.wednesday'),
            i18next.t('DateInput.locale.format.daysOfWeek.thursday'),
            i18next.t('DateInput.locale.format.daysOfWeek.friday'),
            i18next.t('DateInput.locale.format.daysOfWeek.saturday'),
        ],
        monthNames: [
            i18next.t('DateInput.locale.format.monthNames.january'),
            i18next.t('DateInput.locale.format.monthNames.february'),
            i18next.t('DateInput.locale.format.monthNames.march'),
            i18next.t('DateInput.locale.format.monthNames.april'),
            i18next.t('DateInput.locale.format.monthNames.may'),
            i18next.t('DateInput.locale.format.monthNames.june'),
            i18next.t('DateInput.locale.format.monthNames.july'),
            i18next.t('DateInput.locale.format.monthNames.august'),
            i18next.t('DateInput.locale.format.monthNames.september'),
            i18next.t('DateInput.locale.format.monthNames.october'),
            i18next.t('DateInput.locale.format.monthNames.november'),
            i18next.t('DateInput.locale.format.monthNames.december'),
        ],
        cancelLabel: i18next.t('DateInput.locale.format.cancelLabel'),
        applyLabel: i18next.t('DateInput.locale.format.applyLabel'),
    };
    const initialSettings = Object.assign(options, { locale, minDate: '01.01.2000' });
    const inputProps = {
        defaultValue: '',
    };

    if (date) {
        inputProps.defaultValue = inputValue;
    }

    const saveDate = (newDate) => {
        const bodyJSON = {
            [parameterName]: newDate,
        };
        fetch(requestUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(bodyJSON),
        })
            .then((response) => response.json())
            .then(() => {
                if (callback) {
                    callback(newDate.format('YYYY-MM-DD'));
                }
            });
    };

    const handleCancel = (event, picker) => {
        if (date === '') {
            return;
        }
        picker.element.val('');
        if (requestUrl) saveDate('');
        if (callback) {
            callback();
        }
        if (newCallbackNotSingleCancel) {
            newCallbackNotSingleCancel();
        }
    };

    const handleApply = (event, picker) => {
        picker.element.val(picker.startDate.format('DD.MM.YYYY'));
        setInputValue(picker.startDate.format('DD.MM.YYYY'));
        if (requestUrl) saveDate(picker.startDate.format('YYYY-MM-DD'));
        if (newCallback) {
            newCallback(picker.startDate.format('YYYY-MM-DD'));
        }
        if (newCallbackNotSingle) {
            picker.element.val(
                picker.startDate.format('DD.MM.YYYY') + ' - ' + picker.endDate.format('DD.MM.YYYY')
            );
            newCallbackNotSingle({
                start: picker.startDate.format('DD.MM.YYYY'),
                end: picker.endDate.format('DD.MM.YYYY'),
            });
        }
    };

    const handleInputChange = (event) => {
        const value = event.target.value;
        const minDate = moment('01.01.2000', 'DD.MM.YYYY');
        const parsedDate = moment(value, 'DD.MM.YYYY', false);

        if (parsedDate.isValid()) {
            const validDate = parsedDate.isBefore(minDate) ? minDate : parsedDate;
            const formattedDate = validDate.format('DD.MM.YYYY');

            setInputValue(formattedDate);
            if (requestUrl) saveDate(validDate.format('YYYY-MM-DD'));

            if (newCallback) {
                newCallback(validDate.format('YYYY-MM-DD'));
            }
        }
    };

    useEffect(() => {
        setInputValue(date);
    }, [date]);
    return (
        <div className={classNames(s.wrapperInput, { [s.disabled]: isDisabled })}>
            {title && (
                <label className={classNames(s.modalLabelSelect)}>
                    {title}
                    {isRequired && <span>*</span>}
                </label>
            )}
            <div className={s.calendar}>
                <DateRangePicker
                    initialSettings={initialSettings}
                    onApply={handleApply}
                    onCancel={handleCancel}
                    {...inputProps}
                >
                    <input
                        onChange={handleInputChange}
                        placeholder={placeholder ? placeholder : ''}
                        disabled={isDisabled}
                        data-id={parameterName}
                        className={cx(sg.input, s.calendarInput)}
                        type="text"
                    />
                </DateRangePicker>
                <div className={classNames(s.calendarIcon, { [s.disabled]: isDisabled })} />
            </div>
        </div>
    );
}
